module.exports = __webpack_public_path__ + "img/header-advisor.c0e63ad6.png";